(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_7d16d47"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('squareoff-carrara-gallery')) {
    customElements.define('squareoff-carrara-gallery', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[class^="ai-marble-carousel__slider-wrapper-"]');
        this.slides = [...this.querySelectorAll('[class^="ai-marble-carousel__slide-"]')];
        this.dots = [...this.querySelectorAll('[data-carrara-dots] span')];
        if (!this.viewport || !this.slides.length) return;
        this.updateDots = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => {
            const edge = this.viewport.getBoundingClientRect().left;
            let current = 0;
            let nearest = Infinity;
            this.slides.forEach((slide, index) => {
              const distance = Math.abs(slide.getBoundingClientRect().left - edge);
              if (distance < nearest) {
                current = index;
                nearest = distance;
              }
            });
            this.dots.forEach((dot, index) => {
              dot.dataset.active = String(index === current);
            });
          });
        };
        this.viewport.addEventListener('scroll', this.updateDots, { passive: true });
        this.observer = new ResizeObserver(this.updateDots);
        this.observer.observe(this.viewport);
        this.updateDots();
      }

      disconnectedCallback() {
        this.viewport?.removeEventListener('scroll', this.updateDots);
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
